import React, { Component } from 'react';

import './MonthStats.css';
import { withNamespaces } from 'react-i18next';
import {formatBigNumbers} from '../../../Helpers.js';

class MonthCategoryStats extends Component {

    setIcon(category){
        if(this.props.categories.length){
          let discipline = this.props.categories.find(i => i.name === category);
          return (discipline.icon);
        }
      }

    render() {
        let frequentActivitiesList;
        if(this.props.data){
            let mostFrequentActivities = this.props.data.thisMonth.mostFrequentActivities;
            let thisMonthPoints = this.props.data.thisMonth.points;

            frequentActivitiesList = mostFrequentActivities.slice(0,10).map( i =>
                <div className="MonthCategoryStats__category" key={i.discipline}>
                  <div className="MonthCategoryStats__category__icon">
                      <img src={this.setIcon(i.discipline)} alt={i.discipline} title={i.discipline}/>
                  </div>
                  <div className="MonthCategoryStats__category__progress">
                      <div className="MonthCategoryStats__category__progress-bar" style={{ width : (i.points / thisMonthPoints)*100 + '%' }}></div>
                      <div className="MonthCategoryStats__category__progress-value">{formatBigNumbers(i.points)} pts</div>
                  </div>
                </div>
            );
        }

        return (
            <div >
                {frequentActivitiesList}
            </div>
        );
    }
}

export default withNamespaces()(MonthCategoryStats);



// WEBPACK FOOTER //
// ./src/screens/tvboard/MonthStats/MonthCategoryStats.js